export default function GreenCheckIcon ({ className = 'h-6 w-6' })
{
  return(
    <svg
    className={className}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_3020_2177)'>
        <path
          d='M5.61095 2.4381C7.50191 1.1746 9.72505 0.500143 11.9993 0.5C15.0467 0.509042 17.9667 1.72362 20.1215 3.87847C22.2764 6.03334 23.491 8.95338 23.5 12.0008C23.4998 14.275 22.8254 16.4981 21.5619 18.3891C20.2983 20.2802 18.5022 21.7542 16.4009 22.6246C14.2995 23.495 11.9872 23.7228 9.75647 23.279C7.52569 22.8353 5.47658 21.74 3.86828 20.1317C2.25997 18.5234 1.1647 16.4743 0.720975 14.2435C0.277245 12.0128 0.504983 9.70049 1.37539 7.59914C2.2458 5.49779 3.71978 3.70174 5.61095 2.4381Z'
          fill='#0FD08B'
          fillOpacity='0.2'
          stroke='#0FD08B'
        />
        <path
          d='M7 12L10.3333 15.5L17 9'
          stroke='#0FD08B'
          strokeWidth='2'
          strokeMiterlimit='10'
          strokeLinecap='square'
          />
      </g>
      <defs>
        <clipPath id='clip0_3020_2177'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}